<template>
  <div class="select">
    <div v-if="title" class="select_title">{{ title }}</div>
    <v-select v-bind="options" class="style-chooser" v-on="$listeners">
      <template v-slot:open-indicator="{ attributes }">
        <UiBaseIcon
          v-bind="attributes"
          width="10px"
          height="6px"
          icon-name="chevronDown"
          color="#9DA9B8"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import UiBaseIcon from './icons/UiBaseIcon.vue'

Vue.component('v-select', vSelect)

export default {
  components: { UiBaseIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      const defaults = {
        placeholder: this.loading ? 'Загрузка...' : 'Ничего не выбрано',
        searchable: false,
      }

      return Object.assign({}, this.$attrs, defaults)
    },
  },
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';

$color-gray: #b3b3b3;

.style-chooser {
  .vs__search::placeholder {
    color: $color-gray;
  }

  .vs__clear,
  .vs__open-indicator {
    fill: $color-gray !important;
  }

  .vs__dropdown {
    &-menu {
      padding: rem(8px) 0 !important;
      background-color: $white !important;
    }

    &-option {
      padding: 8px 20px;

      &--highlight {
        color: $color-gray-600;
        background: #f5f9fd;
      }
    }

    &-toggle {
      padding: rem(9px) rem(8px) rem(11px);
      font-size: rem(12px);
      color: $color-gray-600;
      background-color: $input-background;
      border: 1px solid transparent;
      border-right: 0;
      border-left: 0;
      outline: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.select {
  &_title {
    margin: 0 0 6px 0;
    font-weight: bold;
  }
}
</style>
